import { useContext } from 'react';

import { CategoricalBarChartCategoryAxisContext } from '../contexts/CategoricalBarChartCategoryAxis.context.js';

export const useCategoricalBarChartCategoryAxisConfig = () =>
  useContext(CategoricalBarChartCategoryAxisContext);
